const initialState = {
}
export default function ShipmentLevelReducer(state = initialState, action) {
    switch (action.type) {
      case 'INITIALIZE_VALUES_SHIPMENT_LEVEL': {
        return Object.assign({}, state, {'LvsData': action.payload})
      }
      default:
        return state
    }
}